import axios from 'axios'

import { LoketBalancesViewModel, LoketLeaveBalanceResource } from '@/models'
import { transformLoketBalancesResource } from '@/services/LoketBalances/transformLoketBalancesResource'

import { getLoketBridgeApiUrl } from './loket'

export async function getLoketLeaveBalance(employmentId: string): Promise<LoketBalancesViewModel> {
    const response = await axios
        .get<LoketLeaveBalanceResource[]>(`${getLoketBridgeApiUrl()}/leave/balance/${employmentId}`)

    return transformLoketBalancesResource(response.data, employmentId)
}
